import React, { useState, useEffect, useReducer } from "react";
import {
  Row,
  Col,
  Card,
  Typography,
  Button,
  message,
  Divider,
  Input,
  Tooltip,
  Form,
  Modal,
  Select,
  Space,
  InputNumber,
  Tag,
} from "antd";
import { EditOutlined, PlusOutlined, DeleteOutlined, UnorderedListOutlined } from "@ant-design/icons";
import { HeaderPage } from "../../../components/headerPage";
import { HeaderTitle } from "../../../components/headerTitle";
import { useNavigate, useParams } from "react-router-dom";
import { TableCustom } from "../../../components/table";
import { reducerRegister } from "../../../helpers/reducers";
import { getGroupByIdApi } from "../../../api/formsColaboradoresGroups";
import {
  createQuestionsApi,
  deleteQuestionsApi,
  getAllQuestionsApi,
  getQuestionsByIdApi,
  updateQuestionsApi,
} from "../../../api/formsColaboradoresQuestions";
import {
  createAlternativesApi,
  deleteAlternativesApi,
  getAllAlternativesApi,
  getAlternativesByIdApi,
  updateAlternativesApi,
} from "../../../api/formsColaboradoresAlternatives";
const { Text } = Typography;

const options_status = [
  { value: 0, label: "Inativo" },
  { value: 1, label: "Ativo" },
];

const options_exige_complemento = [
  { value: 0, label: "Não" },
  { value: 1, label: "Sim" },
];

const rules = {
  descricao: [{ required: true, message: "Digite a descrição!" }],
  cor: [{ required: true, message: "Digite a cor!" }],
  ordem: [{ required: true, message: "Digite a ordem!" }],
  pontuacao: [{ required: true, message: "Selecione o pontuação!" }],
  exige_complemento: [{ required: true, message: "Selecione uma opção!" }],
  status: [{ required: true, message: "Selecione o status!" }],
};

export const FormulariosColaboradoresCadAlternativas = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [dados, dispatch] = useReducer(reducerRegister, []);
  const [showModal, setShowModal] = useState(false);
  const [modal, contextHolder] = Modal.useModal();
  const [idAlt, setIdAlt] = useState(0);
  const [questao, setQuestao] = useState(null);
  const { id_cad_questoes, id_cad_formularios, id_cad_grupos } = useParams();

  useEffect(() => {
    if (id_cad_questoes) {
      getAllAlternatives(id_cad_questoes);
      getQuestionsById(id_cad_questoes);
    }
  }, [id_cad_questoes]);

  const getQuestionsById = async (id) => {
    setLoading(true);
    try {
      const { statusCode, response } = await getQuestionsByIdApi(id);
      if (statusCode === 200) {
        if (!response.data) {
          navigate(`/formularios-colaboradores/formularios/grupos/${id_cad_formularios}/questoes/${id_cad_grupos}`);
        }
        setQuestao(response.data);
      } else {
        message.error(response.message);
        navigate(`/formularios-colaboradores/formularios/grupos/${id_cad_formularios}/questoes/${id_cad_grupos}`);
      }
    } catch (error) {
      message.error("Ops, houve algum erro!");
      navigate(`/formularios-colaboradores/formularios/grupos/${id_cad_formularios}/questoes/${id_cad_grupos}`);
    } finally {
      setLoading(false);
    }
  };

  const getAllAlternatives = async (group_id) => {
    setLoading(true);
    try {
      const { statusCode, response } = await getAllAlternativesApi(group_id);
      if (statusCode === 200) {
        dispatch({ type: "LOAD", payload: response?.data });
      } else {
        message.error(response.message);
      }
    } catch (error) {
      message.error("Ops, houve algum erro!");
    } finally {
      setLoading(false);
    }
  };

  const createAlternatives = async (data) => {
    setLoading(true);
    try {
      const { statusCode, response } = await createAlternativesApi(data);
      if (statusCode === 200) {
        message.success("Registro cadastrado com sucesso!");
        setShowModal(false);
        resetForm();
        if (response?.data) dispatch({ type: "ADD", payload: response?.data });
      } else {
        message.error(response.message);
      }
    } catch (error) {
      message.error("Ops, houve algum erro!");
    } finally {
      setLoading(false);
    }
  };

  const updateAlternatives = async (data) => {
    setLoading(true);
    try {
      const { statusCode, response } = await updateAlternativesApi(data);
      if (statusCode === 200) {
        message.success("Registro alterado com sucesso!");
        setShowModal(false);
        resetForm();
        if (response?.data) dispatch({ type: "UPDATE", payload: response?.data });
      } else {
        message.error(response.message);
      }
    } catch (error) {
      message.error("Ops, houve algum erro!");
    } finally {
      setLoading(false);
    }
  };

  const getAlternativesById = async (id) => {
    setLoading(true);
    try {
      const { statusCode, response } = await getAlternativesByIdApi(id);
      if (statusCode === 200) {
        setShowModal(true);
        form.setFieldsValue({
          descricao: response?.data?.descricao,
          ordem: response?.data?.ordem,
          exige_complemento: response?.data?.exige_complemento,
          pontuacao: response?.data?.pontuacao,
          cor: response?.data?.cor,
          status: response?.data?.status,
        });
        setIdAlt(response.data.id);
      } else {
        message.error(response.message);
      }
    } catch (error) {
      message.error("Ops, houve algum erro!");
    } finally {
      setLoading(false);
    }
  };

  const deleteAlternatives = async (id) => {
    setLoading(true);
    try {
      const { statusCode, response } = await deleteAlternativesApi(id);
      if (statusCode === 200) {
        message.success("Registro deletado com sucesso!");
        dispatch({ type: "DELETE", payload: { id: id } });
      } else {
        message.error(response.message);
      }
    } catch (error) {
      message.error("Ops, houve algum erro!");
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    form.resetFields();
    setIdAlt(0);
  };

  const columns = [
    {
      title: "Descrição",
      dataIndex: "descricao",
    },
    {
      title: "Ordem",
      dataIndex: "ordem",
    },
    {
      dataIndex: "pontuacao",
      title: "Pontuação",
    },
    {
      title: "Cores",
      dataIndex: "cor",
      render: (_, item) => (item.cor ? <Tag color={item.cor}>{item.cor}</Tag> : ""),
      sorter: false,
    },
    {
      dataIndex: "exige_complemento",
      title: "Exige Complemento",
      render: (_, e) => (e.exige_complemento === 1 ? "Sim" : "Não"),
      renderText: (e) => (e.exige_complemento === 1 ? "Sim" : "Não"),
    },
    {
      dataIndex: "status",
      title: "Status",
      render: (_, e) => (e.status === 1 ? "Ativo" : "Inativo"),
      renderText: (e) => (e.status === 1 ? "Ativo" : "Inativo"),
    },
    {
      dataIndex: "acoes",
      title: "Ações",
      width: 150,
      sorter: false,
      render: (_, e) => (
        <Space.Compact>
          <Button loading={loading} onClick={() => getAlternativesById(e.id)} icon={<EditOutlined />} />
          <Button
            danger
            loading={loading}
            icon={<DeleteOutlined />}
            onClick={() => {
              modal.confirm({
                title: "Deseja deletar este registro?",
                okText: "Sim",
                cancelText: "Cancelar",
                onOk() {
                  deleteAlternatives(e.id);
                },
              });
            }}
          />
        </Space.Compact>
      ),
    },
  ];

  const onSubmit = (formData) => {
    formData.id_cad_questoes = id_cad_questoes;
    if (idAlt > 0) {
      formData.id = idAlt;
      updateAlternatives(formData);
    } else {
      createAlternatives(formData);
    }
  };

  const modalFormulario = (
    <Modal
      title={
        <Text style={{ fontSize: 20 }}>
          <EditOutlined /> {idAlt > 0 ? "Editar" : "Adicionar"} Alternativa
        </Text>
      }
      open={showModal}
      onOk={() => form.submit()}
      okText="Salvar"
      width={1200}
      okButtonProps={{ size: "large", loading: loading }}
      cancelButtonProps={{ size: "large", loading: loading }}
      onCancel={() => {
        setShowModal(false);
        resetForm();
      }}>
      <Form form={form} onFinish={onSubmit} layout="vertical" autoComplete="off">
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
            <Form.Item name="descricao" label="Descrição" rules={rules.descricao}>
              <Input size="large" disabled={loading} placeholder="Informe a descrição" />
            </Form.Item>
          </Col>

          <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
            <Form.Item name="ordem" label="Ordem" rules={rules.ordem}>
              <InputNumber
                className="full-width"
                size="large"
                controls={false}
                disabled={loading}
                placeholder="Informe a ordem"
                min={1}
                max={1000}
                step={1}
              />
            </Form.Item>
          </Col>

          {questao?.exige_pontuacao === 1 && (
            <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
              <Form.Item name="pontuacao" label="Pontuação" rules={rules.pontuacao}>
                <InputNumber
                  className="full-width"
                  size="large"
                  controls={false}
                  disabled={loading}
                  placeholder="Informe a pontuacao"
                  min={0}
                  max={1000}
                  step={1}
                />
              </Form.Item>
            </Col>
          )}

          <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
            <Form.Item name="cor" label="Cor" rules={rules.cor}>
              <Input size="large" disabled={loading} placeholder="Informe a cor" />
            </Form.Item>
          </Col>

          <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
            <Form.Item name="exige_complemento" label="Exige Complemento" rules={rules.exige_complemento}>
              <Select
                size="large"
                placeholder="Selecione uma opção"
                disabled={loading}
                style={{ width: "100%" }}
                options={options_exige_complemento}
              />
            </Form.Item>
          </Col>

          <Col className="gutter-row" xs={24} sm={24} md={12} lg={12} xl={12}>
            <Form.Item name="status" label="Status" rules={rules.status}>
              <Select
                size="large"
                placeholder="Selecione o status"
                disabled={loading}
                style={{ width: "100%" }}
                options={options_status}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );

  return (
    <Row align="middle" justify="center" className="content-row">
      {modalFormulario}
      <Col span={24} align="middle" justify="center">
        <Col xs={24} sm={24} md={22} lg={22} xl={20} xxl={16} align="left">
          <div className="content-item">
            <HeaderPage
              title="Formulários Colaboradores"
              onClickBack={() =>
                navigate(
                  `/formularios-colaboradores/formularios/grupos/${id_cad_formularios}/questoes/${id_cad_grupos}`
                )
              }
            />
            <HeaderTitle
              title={["Formulários", "Grupos", "Questões", "Alternativas"]}
              subtitle={`Questão - ${questao?.descricao ?? ""}`}
              icon={<UnorderedListOutlined />}
              loading={loading}
            />
            <Divider />
            <Card bordered={false} bodyStyle={{ padding: "3%" }}>
              <TableCustom
                extraHeaderComponents={
                  <Tooltip title="Adicionar Registro">
                    <Button
                      type="primary"
                      icon={<PlusOutlined />}
                      onClick={() => {
                        setShowModal(true);
                        resetForm();
                      }}
                      loading={loading}>
                      Novo
                    </Button>
                  </Tooltip>
                }
                loading={loading}
                columns={columns}
                dataSource={dados}
              />
            </Card>
          </div>
        </Col>
      </Col>
      {contextHolder}
    </Row>
  );
};
